(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["ss-drop-early-access"] && !Shopify.designMode) return;
  try {
    (() => {
    if (customElements.get('jmn-drop')) return;

    const UNLOCKED_ATTR = 'data-jmn-drop-unlocked';
    const OPEN_ATTR = 'data-jmn-drop-open';
    const STORAGE_KEY = 'jmn-drop-passwords';
    const RELOAD_PARAM = 'drop';

    /** Igual que en Liquid: strip | downcase | remove: ' ' */
    const normalizePassword = (value) =>
      String(value || '')
        .trim()
        .toLowerCase()
        .replace(/ /g, '');

    /** Para comparar textos de Klaviyo sin depender de espacios ni mayúsculas */
    const textKey = (value) =>
      String(value || '')
        .replace(/\s+/g, ' ')
        .trim()
        .toLowerCase();

    const nowSeconds = () => Math.floor(Date.now() / 1000);
    const pad = (value) => String(value).padStart(2, '0');

    const readStoredPasswords = () => {
      try {
        const list = JSON.parse(localStorage.getItem(STORAGE_KEY) || '[]');
        return Array.isArray(list) ? list.filter((item) => typeof item === 'string') : [];
      } catch (error) {
        return [];
      }
    };

    const storePassword = (password) => {
      try {
        const list = readStoredPasswords().filter((item) => item !== password);
        list.unshift(password);
        localStorage.setItem(STORAGE_KEY, JSON.stringify(list.slice(0, 10)));
      } catch (error) {
        // Sin localStorage (incógnito estricto): sigue desbloqueado hasta recargar.
      }
    };

    const sha256 = async (text) => {
      const buffer = await crypto.subtle.digest('SHA-256', new TextEncoder().encode(text));
      return Array.from(new Uint8Array(buffer), (byte) => byte.toString(16).padStart(2, '0')).join('');
    };

    class JmnDrop extends HTMLElement {
      config = {};
      timer = null;
      observers = [];
      busy = false;
      abortController = null;

      connectedCallback() {
        try {
          this.config = JSON.parse(this.querySelector('script[data-drop-config]')?.textContent || '{}');
        } catch (error) {
          this.config = {};
        }

        this.abortController = new AbortController();
        const { signal } = this.abortController;

        // Delegación: los formularios pueden re-renderizarse sin perder los listeners.
        this.addEventListener('submit', this.onSubmit, { signal });
        this.addEventListener('input', this.onInput, { signal });

        const section = this.closest('.shopify-section') || document;
        section.addEventListener('shopify:product:select', this.onProductSelect, { signal });
        window.addEventListener('popstate', this.onPopState, { signal });

        this.syncVariantFromUrl();
        this.startCountdown();
        if (this.config.phase === 'early') this.restoreUnlock();
        this.observeKlaviyo();
      }

      disconnectedCallback() {
        this.abortController?.abort();
        if (this.timer) clearInterval(this.timer);
        this.timer = null;
        this.observers.forEach((observer) => observer.disconnect());
        this.observers = [];
      }

      get i18n() {
        return this.config.i18n || {};
      }

      /* ---------- Eventos ---------- */

      onSubmit = (event) => {
        const form = event.target;
        if (!(form instanceof HTMLFormElement)) return;

        if (form.matches('[data-drop-unlock]')) {
          event.preventDefault();
          this.unlock(form);
        } else if (form.matches('.ss-drop__form')) {
          event.preventDefault();
          this.addToCart(form);
        }
      };

      onInput = (event) => {
        if (event.target instanceof HTMLInputElement && event.target.name === 'drop_password') {
          this.showError(false);
        }
      };

      /** Evento estándar de Horizon 4 al cambiar de variante (lo lanza <variant-picker>). */
      onProductSelect = (event) => {
        const target = event.target;
        if (target instanceof Element && target.closest('product-card, dialog')) return;

        const variantId = event.detail?.variantId;
        this.setVariant(variantId ? String(variantId) : null);

        event.promise
          ?.then((result) => {
            const detail = result?.detail;
            if (!detail) return;
            if (detail.productId && String(detail.productId) !== String(this.config.productId)) return;

            const resource = detail.resource;
            if (resource && resource.id) {
              this.setVariant(String(resource.id), Boolean(resource.available));
            } else if (resource === null) {
              this.setVariant(null);
            }
          })
          .catch(() => {});
      };

      onPopState = () => this.syncVariantFromUrl();

      /* ---------- Countdown y fases ---------- */

      startCountdown() {
        const { phase, start, public: publicAt, preview } = this.config;
        const target = phase === 'pre' ? start : phase === 'early' ? publicAt : 0;
        if (!target || preview) return;

        const tick = () => {
          const remaining = target - nowSeconds();
          if (remaining <= 0) {
            this.renderCountdown(0);
            if (this.timer) clearInterval(this.timer);
            this.timer = null;
            this.onTargetReached(phase);
            return false;
          }
          this.renderCountdown(remaining);
          return true;
        };

        if (tick()) this.timer = setInterval(tick, 1000);
      }

      renderCountdown(remaining) {
        const values = {
          days: Math.floor(remaining / 86400),
          hours: Math.floor((remaining % 86400) / 3600),
          minutes: Math.floor((remaining % 3600) / 60),
          seconds: remaining % 60,
        };

        this.querySelectorAll('[data-unit]').forEach((element) => {
          const text = pad(values[element.dataset.unit] ?? 0);
          if (element.textContent !== text) element.textContent = text;
        });
      }

      onTargetReached(phase) {
        if (phase === 'pre') {
          // HTML cacheado: recarga una sola vez para que Liquid calcule la fase nueva.
          const url = new URL(window.location.href);
          if (url.searchParams.has(RELOAD_PARAM)) return;
          url.searchParams.set(RELOAD_PARAM, String(nowSeconds()));
          window.location.replace(url.toString());
        } else if (phase === 'early') {
          // Venta abierta: se muestra el botón sin recargar.
          document.documentElement.setAttribute(OPEN_ATTR, '');
        }
      }

      /* ---------- Contraseña ---------- */

      async matchesHash(password) {
        const { hash, productId } = this.config;
        if (!hash || !password || !window.crypto?.subtle) return false;
        try {
          return (await sha256(password + String(productId))) === hash;
        } catch (error) {
          return false;
        }
      }

      async restoreUnlock() {
        for (const password of readStoredPasswords()) {
          if (await this.matchesHash(password)) {
            this.setUnlocked();
            return;
          }
        }
      }

      async unlock(form) {
        const input = form.querySelector('input[name="drop_password"]');
        const password = normalizePassword(input?.value);

        if (!(await this.matchesHash(password))) {
          this.showError(true);
          input?.focus();
          input?.select();
          return;
        }

        storePassword(password);
        this.showError(false);
        this.setUnlocked();
        this.announce(this.i18n.unlocked);
        this.querySelector('[data-drop-add]:not([disabled])')?.focus();
      }

      setUnlocked() {
        document.documentElement.setAttribute(UNLOCKED_ATTR, '');
      }

      showError(visible) {
        const error = this.querySelector('[data-drop-error]');
        if (!error) return;
        error.textContent = visible ? this.i18n.error || '' : '';
        error.hidden = !visible;
        this.querySelector('input[name="drop_password"]')?.setAttribute('aria-invalid', visible ? 'true' : 'false');
      }

      announce(text) {
        const status = this.querySelector('[data-drop-status]');
        if (!status || !text) return;
        status.textContent = '';
        requestAnimationFrame(() => {
          status.textContent = text;
        });
      }

      /* ---------- Variantes ---------- */

      syncVariantFromUrl() {
        const variants = this.config.variants || {};
        const fromUrl = new URL(window.location.href).searchParams.get('variant');
        const input = this.querySelector('.ss-drop__form input[name="id"]');

        if (fromUrl && Object.prototype.hasOwnProperty.call(variants, fromUrl)) {
          this.setVariant(fromUrl);
        } else if (input?.value) {
          this.setVariant(input.value);
        }
      }

      /**
       * @param {string | null} variantId - null si la combinación no existe
       * @param {boolean} [available] - disponibilidad real si la conocemos
       */
      setVariant(variantId, available) {
        const input = this.querySelector('.ss-drop__form input[name="id"]');
        const button = this.querySelector('[data-drop-add]');
        if (!input || !button) return;

        const variants = this.config.variants || {};
        if (variantId && typeof available === 'boolean') variants[variantId] = available;

        const isAvailable = Boolean(variantId) && variants[variantId] === true;
        if (variantId) input.value = variantId;

        this.setButtonState(button, isAvailable);
      }

      setButtonState(button, isAvailable) {
        button.disabled = !isAvailable;
        const label = button.querySelector('[data-drop-add-label]') || button;
        const text = isAvailable ? this.i18n.add : this.i18n.soldout;
        if (text && label.textContent !== text) label.textContent = text;
      }

      /* ---------- Carrito ---------- */

      async addToCart(form) {
        const button = form.querySelector('[data-drop-add]');
        if (!button || button.disabled || this.busy) return;

        this.busy = true;
        button.setAttribute('aria-busy', 'true');

        const routes = window.Theme?.routes || {};
        const cartUrl = routes.cart_url || '/cart';
        let added = false;

        try {
          // Eventos estándar que usan cart-icon, cart-items-component y cart-drawer de Horizon.
          const { CartLinesUpdateEvent, CartErrorEvent } = await import('@shopify/events');

          const formData = new FormData(form);
          const variantId = String(formData.get('id'));
          const quantity = Number(formData.get('quantity')) || 1;
          const sectionIds = Array.from(
            document.querySelectorAll('cart-items-component[data-section-id]'),
            (element) => element.dataset.sectionId
          ).filter(Boolean);
          if (sectionIds.length) formData.append('sections', sectionIds.join(','));

          const response = await fetch(routes.cart_add_url || '/cart/add.js', {
            method: 'POST',
            headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
            body: formData,
          });
          const data = await response.json().catch(() => ({}));

          if (response.status === 422 || data.status === 422) {
            const variants = this.config.variants || {};
            variants[variantId] = false;
            this.setButtonState(button, false);
            this.announce(this.i18n.soldout);
            this.dispatchEvent(
              new CartErrorEvent({
                error: data.description || data.message || 'Sold out',
                code: 'INVALID',
                detail: { description: data.description, errors: data.errors },
              })
            );
            return;
          }

          if (!response.ok || data.status) {
            throw new Error(data.description || `Add to cart failed (${response.status})`);
          }

          added = true;

          const cart = await fetch(`${cartUrl}.js`, {
            headers: { Accept: 'application/json' },
            credentials: 'same-origin',
          }).then((cartResponse) => {
            if (!cartResponse.ok) throw new Error(`Cart fetch failed (${cartResponse.status})`);
            return cartResponse.json();
          });

          const deferred = CartLinesUpdateEvent.createPromise();
          this.dispatchEvent(
            new CartLinesUpdateEvent({
              action: 'add',
              context: 'product',
              lines: [{ merchandiseId: variantId, quantity }],
              promise: deferred.promise,
            })
          );
          deferred.resolve({
            cart: CartLinesUpdateEvent.createCartFromAjaxResponse(cart),
            detail: {
              items: cart.items,
              sections: data.sections,
              itemCount: quantity,
              productId: String(this.config.productId),
              source: 'jmn-drop',
              sourceId: this.id || 'jmn-drop',
              didError: false,
            },
          });

          this.announce(this.i18n.added);
        } catch (error) {
          console.error('[jmn-drop]', error);
          if (added) {
            // Ya está en el carrito: no repetir el envío, solo llevar al carrito.
            window.location.href = cartUrl;
          } else {
            // Respaldo: envío nativo del formulario (no vuelve a disparar 'submit').
            form.submit();
          }
        } finally {
          this.busy = false;
          button.removeAttribute('aria-busy');
        }
      }

      /* ---------- Klaviyo ---------- */

      observeKlaviyo() {
        if (!this.config.klaviyo?.translate) return;

        const options = { childList: true, subtree: true, characterData: true };

        this.querySelectorAll('[data-drop-klaviyo]').forEach((root) => {
          const observer = new MutationObserver(() => {
            // Desconectar mientras traducimos para no reaccionar a nuestros propios cambios.
            observer.disconnect();
            this.translateKlaviyo(root);
            observer.observe(root, options);
          });

          this.translateKlaviyo(root);
          observer.observe(root, options);
          this.observers.push(observer);
        });
      }

      translateKlaviyo(root) {
        const { source = {}, target = {} } = this.config.klaviyo || {};

        root.querySelectorAll('input[type="email"]').forEach((input) => {
          if (target.email && input.placeholder !== target.email) {
            input.placeholder = target.email;
            input.setAttribute('aria-label', target.email);
          }
        });

        if (target.button) {
          const sourceButton = textKey(source.button);
          const targetButton = textKey(target.button);

          root.querySelectorAll('button').forEach((button) => {
            const current = textKey(button.textContent);
            if (!current || current === targetButton || current.length < 3) return;
            if (sourceButton && current !== sourceButton) return;
            button.textContent = target.button;
          });
        }

        this.replaceKlaviyoText(root, source.legal, target.legal, true);
        this.replaceKlaviyoText(root, source.success, target.success, false);
      }

      /** Sustituye el elemento más interno cuyo texto empieza por el texto original en español. */
      replaceKlaviyoText(root, sourceText, targetText, asHtml) {
        const key = textKey(sourceText).slice(0, 40);
        if (!key || !targetText) return;

        const matches = Array.from(root.querySelectorAll('p, span, div, label, h1, h2, h3, h4')).filter(
          (element) => !element.querySelector('input, button, form') && textKey(element.textContent).startsWith(key)
        );
        const deepest = matches.filter((element) => !matches.some((other) => other !== element && element.contains(other)));

        deepest.forEach((element) => {
          if (asHtml) {
            element.innerHTML = targetText;
          } else {
            element.textContent = targetText;
          }
        });
      }
    }

    customElements.define('jmn-drop', JmnDrop);
  })();
  } catch(e) { console.error(e); }
})();

})();
